<template>
	<div class="polyline-status-bar">
		<div class="item item-1">
			<div class="point"></div>
			<div class="text">新增</div>
		</div>
		<div class="item item-2">
			<div class="point"></div>
			<div class="text">风险区</div>
		</div>
		<div class="item" v-for="(value,key) in polylineInfo">
			<div class="point" :style="{background:value.color}" :key="key"></div>
			<div class="text">{{value.text}}</div>
		</div>
	</div>
</template>

<script>
	import polylineInfo from '../polyline'
	export default {
		data(){
			return{
				appName:process.env.VUE_APP_NAME,
				polylineInfo
			}
		}
	}
</script>

<style scoped>
	.polyline-status-bar {
		position: absolute;
		z-index: 100;
		background: rgba(0, 0, 0, 0.3);
		right: 10px;
		bottom: 120px;
		color: #fff;
		font-size: 12px;
		padding: 10px;
		border-radius: 4px;
	}

	.polyline-status-bar .item {
		display: flex;
		align-items: center;
		margin-bottom: 5px;
	}

	.polyline-status-bar .item-1 .point{
		background: #fff;
	}

	.polyline-status-bar .item-2 .point{
		background: #93259c;
	}

	.polyline-status-bar .point {
		width: 8px;
		height: 8px;
		border-radius: 100%;
		margin-right: 5px;
	}
</style>